import type { ReactNode } from "react";

interface FullScreenMessageProps {
  testId: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

/**
 * FullScreenMessage — единственный вид полноэкранного сообщения витрины до старта каталога:
 * магазин недоступен, нет сети, ссылка недействительна (docs/07-miniapp-ux.md §2.1).
 */
export function FullScreenMessage({ testId, title, description, action }: FullScreenMessageProps) {
  return (
    <div data-testid={testId} className="flex min-h-screen items-center justify-center bg-bg p-6">
      <div className="flex max-w-sm flex-col items-center gap-3 rounded-card bg-surface p-8 text-center">
        <p className="text-lg font-semibold text-text">{title}</p>
        {description ? <p className="text-hint">{description}</p> : null}
        {action}
      </div>
    </div>
  );
}
